import { initFaqSection } from "@/modules/section-faq";
import { initFooterSection } from "@/modules/section-footer";
import ready from "@/scripts/helpers/dom/ready";
import { Slicker } from '@rooi/slicker/esm2015/index';
import cookiePopup from "@/modules/popup-cookie";
import { clickTracker } from "@/scripts/helpers/clickTracker";
import { headerFunctions } from "@/modules/section-header";




const slicker = new Slicker(document.querySelector('.js-slider'), {
  dots: true,
  arrows: false,
  infinite: false,
  initialSlide: 0,
  speed: 0,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: false,
  variableWidth: false,
  draggable: false,
  autoplay: true,
  adaptiveHeight: true
});


ready( () => {
  headerFunctions();
  initFaqSection();
  initFooterSection();
  clickTracker();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});